import Vas from '@/service/vas'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getproductvacs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vas.getproductvacs(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getvacconfigs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vas.getvacconfigs(payload), {
        type: 'info',
        success,
        fail
      })
    },
    updatevacconfig(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vas.updatevacconfig(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getvaclibs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vas.getvaclibs(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getvaclib(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vas.getvaclib(payload), {
        type: 'info',
        success,
        fail
      })
    },
    deletevaclib(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vas.deletevaclib(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatevaclib(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vas.updatevaclib(payload), {
        type: 'action',
        success,
        fail
      })
    },
    copyvaclib(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vas.copyvaclib(payload), {
        type: 'info',
        success,
        fail
      })
    },
    savetovaclib(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vas.savetovaclib(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
